import { render, staticRenderFns } from "./IntersectionObserver.vue?vue&type=template&id=12d51215"
import script from "./IntersectionObserver.vue?vue&type=script&lang=js"
export * from "./IntersectionObserver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports